import { inject, observer } from 'mobx-react'
import React from 'react'
import MoveGeometryTooltip from 'components/common/tooltips/MoveGeometryTooltip'
import { withTranslation } from 'react-i18next'
import { HugeiconsIcon } from '@hugeicons/react'
import { FolderExportIcon } from '@hugeicons/core-free-icons'

const MoveGeometryButton = ({ title, group, onSubmit, uiStore, dataStore, lgIcon, t }) => (
  <button
    className='nooutline move-geometry'
    onClick={(e) => {
      e.stopPropagation()
      dataStore.selectedCopyGroup = null
      uiStore.openClickTooltip({
        style: {
          width: 340
        },
        position: 'right-start',
        selector: '.tools.popup-menu',
        text: (
          <MoveGeometryTooltip
            title={title || t('GLOBAL.MOVE_REGION', { defaultValue: 'Move region' })}
            group={group}
            onSubmit={onSubmit}
          />
        )
      })
    }}
  >
    <HugeiconsIcon icon={FolderExportIcon} size={18} className='popup-menu__icon' />
    <span>{t('GLOBAL.MOVE_REGION')}</span>
  </button>
)

export default withTranslation()(inject('uiStore', 'dataStore')(observer(MoveGeometryButton)))
